import { render } from "./TicketsReservations.vue?vue&type=template&id=e963a784&ts=true&lang=pug"
import script from "./TicketsReservations.vue?vue&type=script&lang=ts&setup=true"
export * from "./TicketsReservations.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/home/runner/work/affolterNET.Tickets/affolterNET.Tickets/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__